import axios from "@axios";

export default {
  namespaced: true,
  state: {
    logItems: [],
    statistics: {},
    TransactionsStatistics : {},
    loading: false,
  },
  getters: {
    logItems(state) {
      return state.logItems;
    },
    statistics(state) {
      return state.statistics;
    },
    loading(state) {
      return state.loading;
    },
    TransactionsStatistics(state){
      return state.TransactionsStatistics;
    },
  },
  mutations: {
    setLogItems(state, val) {
      state.logItems = val;
    },
    setStatistics(state, val) {
      state.statistics = val;
    },
    setLoading(state, val) {
      state.loading = val;
    },
    setTransactionsStatistics(state, val) {
      state.TransactionsStatistics = val;
    },
  },
  actions: {
    async fetchDashboardData({ commit }) {
      commit("setLoading", true);
      try {
        const data = await axios
          .get("v2/ministry/dashboard")
          .then((res) => res.data);
        commit("setStatistics", data.data.statistics);
        commit("setLogItems", data.data.log);
      } catch (err) {
      } finally {
        commit("setLoading", false);
      }
    },
    async fetchTransactionsStatistics({ commit }) {
      commit("setLoading", true);
      try {
        const data = await axios
          .get("v2/ministry/transactions-statistics")
          .then((res) => res.data);
        commit("setTransactionsStatistics", data.data);
      } catch (err) {
      } finally {
        commit("setLoading", false);
      }
    },
  },
};
